import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../lib/api';

// Simple module-cache so we don't refetch on every route change
let _cache = null; let _pending = null;
async function loadHomeCfg() {
    if (_cache) return _cache;
    if (_pending) return _pending;
    _pending = api.get('/home/public')
        .then(r => { _cache = r.data || {}; return _cache; })
        .catch(() => ({}))
        .finally(() => { _pending = null; });
    return _pending;
}
export function invalidateHomeCache() { _cache = null; }

/** Top announcement bar. Hidden on admin routes and when disabled or message empty. */
export default function TopBar() {
    const loc = useLocation();
    const [tb, setTb] = useState(null);
    useEffect(() => {
        let mounted = true;
        loadHomeCfg().then(c => { if (mounted) setTb(c?.top_bar || null); });
        return () => { mounted = false; };
    }, []);

    if (loc.pathname.startsWith('/dharmikdashboard')) return null;
    if (!tb || !tb.enabled || !(tb.message || '').trim()) return null;

    const inner = (
        <div className="px-4 py-1.5 text-xs sm:text-sm text-center flex items-center justify-center gap-2 flex-wrap">
            <span className="font-medium">{tb.message}</span>
            {tb.link_label && tb.link_url && (
                <span className="underline underline-offset-2 font-semibold">{tb.link_label} →</span>
            )}
        </div>
    );
    return (
        <div
            className="w-full"
            style={{ background: tb.bg_color || '#166534', color: tb.text_color || '#ffffff' }}
            data-testid="top-bar"
        >
            {tb.link_url ? (
                <Link to={tb.link_url} className="block hover:opacity-90 transition-opacity">{inner}</Link>
            ) : inner}
        </div>
    );
}
